<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :lockable="lockable"
            :has-lock="hasLock"
            :document-lock="documentLock"
            @force-takeover="attemptTakeover"
            @takeover="takeOver"

            :show-preview-button="shouldShowPreviewButton()"
            @click-preview="submitPreviewSite(form.language.iso, form.uri)"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :seo-data="data ? data.latest_seo : null"

            model="App\Models\HtmlSitemap"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <base-page-fields
            class="mt-3"
            :form="form"
            :errors="errors"
            :language="form.language"
            :publishable="publishable"
        ></base-page-fields>

        <input type="hidden" name="_token" :value="csrf"/>
        <input v-if="data" type="hidden" name="_method" value="patch"/>
    </form>
</template>

<script>
import crudForm from '../mixins/crudForm'
import pageFormData from '../mixins/pageFormData'

export default {
    name: 'HtmlSitemapForm',
    mixins: [crudForm, pageFormData],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                created_at: this.getFormData("created_at") || new Date(),
                updated_at: this.getFormData("updated_at") || new Date(),
                variants: this.getFormData('variants', []),
            },
        }
    },
}
</script>
